import { firstLettersOfWeekDays } from '@weenat/client/dist/core/history'
import Text from 'app/src/kit/Text'
import capitalize from 'lodash-es/capitalize'
import React from 'react'
import Grid from '../Grid'

interface CalendarGridProps {
  dayPadding: number
}

const CalendarGrid: FC<CalendarGridProps> = ({ children }) => {
  const rows = Math.ceil(React.Children.count(children) / 7)
  return (
    <Box $p='md'>
      {/* Grid Header (days list) */}
      <Flex $py='sm' $mb='md' $alignItems='center'>
        {firstLettersOfWeekDays().map((letter, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={`${i}-${letter}`} $flex={1 / 7}>
            <Text $textAlign='center' $color={'grayscale.700'}>
              {capitalize(letter)}
            </Text>
          </Box>
        ))}
      </Flex>
      {/* Grid */}
      <Grid $templateRows={`repeat(${rows}, 1fr)`} $templateColumns='repeat(7, minmax(0, 1fr))'>
        {children}
      </Grid>
    </Box>
  )
}

export default CalendarGrid
